export default __webpack_public_path__ + "static/media/supper_apps_logo.4ea1b241.svg";